/**
* LR Accordion JS
* -----------------------------------------------------------------------------
*
* All the JS for the LR Accordion component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'lr-accordion',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.lr-accordion__title' ).on( 'toggleAfter', ( event ) => {
        $( event.target ).next().slideToggle();
      } );
      $( '.lr-accordion__first-accordion > button' ).trigger( 'click' );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'lr-accordion', COMPONENT );
} )( app );
